module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Fb-Ga-Hc-Ia.448b31f0.png";